import { combineReducers } from 'redux';
import { menus } from './menus';
import { reducer as notificationsReducer } from 'reapop';
import { reducer as formReducer } from 'redux-form';
import LoyaltyAccountInfoReducer from './LoyaltyAccountInfoReducer';
import LoyaltyGiftReducer from './LoyaltyGiftReducer';
import LoyaltyQuestReducer from './LoyaltyQuestReducer';
import CategoryMenuReducer from './CategoryMenuReducer';
import LoginReducer from './LoginReducer';
import {config} from './config';
import userProfile from './userProfile';
import contract from './contract';
import FunctionSupportReducer from './FunctionSupportReducer';

import app from './app';
import common from './common';

import { USER_LOGOUT } from 'model/constants/actionConstants';

const appReducer = combineReducers({
	app,common,
	menus,
	config,
	CategoryMenuReducer,
	notifications: notificationsReducer(),
	form: formReducer,
	LoyaltyAccountInfoReducer,
	LoyaltyGiftReducer,
	LoyaltyQuestReducer,
	userProfile,
	contract,
	LoginReducer,
	FunctionSupportReducer
});

const rootReducer = (state, action) => {
	if (action.type === USER_LOGOUT) {
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};

export default rootReducer;
